/**
 * Share links look like `https://host/b/<bridgeId>#<key>`. The key sits in
 * the fragment, which browsers never send to the server.
 *
 * Inside the native app the links carry the server's origin (lib/app.ts), so
 * any browser can open them.
 */

import { platform } from '@platform';

import { publicOrigin } from './app';

export function bridgePath(bridgeId: string, key?: string): string {
  return platform.bridgePath(bridgeId, key);
}

export function shareLink(bridgeId: string, key: string, origin: string = publicOrigin()): string {
  return `${platform.linkBase(origin)}${bridgePath(bridgeId, key)}`;
}

export function connectLink(origin: string = publicOrigin()): string {
  return `${platform.linkBase(origin)}/connect`;
}

/**
 * Reads the key from a location hash (`#key`, `#k=…`), or in the preview from its search (`?k=…`, since the preview
 * routes through the hash). The real app never takes a key from the query string: it would have reached the server.
 */
export function keyFromHash(hash: string, search = ''): string | null {
  return platform.keyFromLocation(hash, search);
}
